import { client } from '../../core/client';

import type {
  ResponsePaymentDetails,
  DataResponse,
  ResponseArtifact,
  CreateInvoiceResponse,
  PaymentInfoRequest,
  PaymentReceipt,
  ResponsePaymentStatus,
} from '../../types';

export const pay = {
  services: {
    createInvoice: (formData: PaymentInfoRequest): Promise<CreateInvoiceResponse> => {
      return client.post(`/defrayments/payments/invoice`, formData);
    },
    getPaymentDetails: (operId: number): Promise<ResponsePaymentStatus> => {
      return client.get(`/payments/${operId}/status`);
    },
    paymentInfo: (formData: PaymentInfoRequest): Promise<DataResponse<ResponsePaymentDetails>> => {
      return client.post(`/defrayments/payments/info`, formData);
    },
  },
  getPayments: (): Promise<DataResponse<PaymentReceipt[]>> => {
    return client.get('/payments/user');
  },
  downloadReceipt: (invoiceId: string): Promise<ResponseArtifact> => {
    const headers = new Headers();
    headers.set('Accept', 'application/pdf');

    return client.get(`/payments/receipt/${invoiceId}`, { headers });
  },
};
